module.exports = __webpack_public_path__ + "img/lyndus_logo.d1707f42.png";